import MovieResult from './MovieResult';

export default MovieResult;
